import {
  BottomNavigation as MUIBottomNavigation,
  BottomNavigationAction,
  Box,
} from '@mui/material';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { IconNames } from 'sprite/types';

import { accountRoutes, ticketRoutes } from 'constants/navigation.constants';
import { Routes } from 'constants/routes.constants';

import LinkUnstyled from 'components/@common/LinkUnstyled';
import Icon from 'components/@icons/Icon';

enum Actions {
  Home = 'home',
  Tickets = 'tickets',
  Account = 'account',
}

const mapRouteToAction = (route: string) => {
  if (accountRoutes.includes(route)) return Actions.Account;
  if (ticketRoutes.includes(route)) return Actions.Tickets;
  return Actions.Home;
};

interface Props {
  name: IconNames;
}

const ActionIcon = ({ name }: Props) => (
  <Box
    sx={{
      display: 'flex',
      px: '14px',
      py: 1,
      borderRadius: '21px',
    }}
  >
    <Icon name={name} />
  </Box>
);

const BottomNavigation = () => {
  const { pathname } = useRouter();
  const [value, setValue] = useState(mapRouteToAction(pathname));

  return (
    <div>
      <Box
        sx={[
          {
            bgcolor: 'background.paper',
          },
          (theme) => ({
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            display: { md: 'none' },
            pb: 'env(safe-area-inset-bottom)',
            borderTop: `1px solid ${theme.vars.palette.grey[800]}`,
            zIndex: theme.zIndex.appBar + 99,
          }),
        ]}
      >
        <MUIBottomNavigation
          showLabels
          value={value}
          onChange={(_, newValue) => {
            setValue(newValue);
          }}
        >
          <BottomNavigationAction
            icon={<ActionIcon name="Home" />}
            value={Actions.Home}
            component={LinkUnstyled}
            href={Routes.Home}
            aria-label={Actions.Home}
          />
          <BottomNavigationAction
            icon={<ActionIcon name="Ticket" />}
            value={Actions.Tickets}
            component={LinkUnstyled}
            href={Routes.AccountTickets}
            aria-label={Actions.Tickets}
          />
          <BottomNavigationAction
            icon={<ActionIcon name="Profile" />}
            value={Actions.Account}
            component={LinkUnstyled}
            href={Routes.Account}
            aria-label={Actions.Account}
          />
        </MUIBottomNavigation>
      </Box>
      <Box
        sx={{
          height: 72,
          display: { xs: 'block', md: 'none' },
        }}
      />
    </div>
  );
};

export default BottomNavigation;
